module.exports = __webpack_public_path__ + "static/an-educator-first-03b609a163f4168c6066a4f28220aaee.jpg";